import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { HelmetProvider } from "react-helmet-async";
import { useEffect } from "react";

// Ant Design CSS is already being loaded via external CSS file

import Router from "./router";
import i18n from "./translation";

import { createRoot } from "react-dom/client";

const App = () => {
  useEffect(() => {
    // Defer analytics loading to after critical rendering
    const initializeAnalytics = async () => {
      // Wait for critical rendering to complete
      const loadAnalytics = async () => {
        try {
          // Use dynamic imports with chunk names for better optimization
          const [, { trackUserSource }] = await Promise.all([
            import(/* webpackChunkName: "firebase-config" */ "./firebase/config"),
            import(/* webpackChunkName: "analytics-utils" */ "./utils/analytics")
          ]);

          trackUserSource();
        } catch (error) {
          console.warn("Analytics initialization failed:", error);
        }
      };

      if ('requestIdleCallback' in window) {
        requestIdleCallback(loadAnalytics, { timeout: 3000 });
      } else {
        setTimeout(loadAnalytics, 2000);
      }
    };

    initializeAnalytics();
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <I18nextProvider i18n={i18n}>
          <Router />
        </I18nextProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
};

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);
root.render(<App />);
